<template>
  <div class="flex items-center justify-between w-11/12 max-w-3xl mx-auto">
    <h1 class="block text-2xl font-bold leading-6 text-gray-900">{{ taskName }} Checklists</h1>
    <TButton color="indigo" size="sm" label="Add checklist" @click="handleAddChecklist" />
  </div>
</template>

<script>
export default {
  props: {
    taskName: { type: String, required: true },
  },
  methods: {
    handleAddChecklist() {
      this.$emit('addChecklist');
    },
  },
};
</script>
